import { uniq as _uniq } from 'lodash'
import { identity } from 'rxjs'
import { mergeAll, switchMap, toArray } from 'rxjs/operators'
import Component from 'vue-class-component'
import { faLock, faLockOpen, faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SEARCH_TYPES } from '@skinsoft/const'
import { Container, Item } from '@skinsoft/types'
import { ContainerDataStore } from '@skinsoft/entity/src/container'
import { MOVEMENT_ITEM_CARD_LOCATION_CHANGED, UPDATE_ITEM_MOVEMENT_PAGE } from '@skinsoft/events'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { ItemCard } from '@skinsoft/ui'
import { MovementItemCard } from '../movement-item-card'

require('./container-card.scss')

declare const ITEM_SEARCH_TYPES: string[]

@Component({
    components: {
        sMovementItemCard: MovementItemCard,
        sItemCard: ItemCard,
    },
    props: ['container', 'inMovementDisplay', 'displayType'],
    name: 's-container-card',
    template: require('./container-card.html'),
})
export class ContainerCard extends ReactiveVue {
    private container: Container

    private subItems: Item[] = []
    private subContainers: Container[] = []
    private subAccessories: Item[] = []

    private inMovementDisplay: boolean
    private displayType: boolean

    private isFetchingContent: boolean = false
    private contentFetched: boolean = false

    private $containerDataStore: ContainerDataStore

    private closedContainerIcon = faLock
    private openedContainerIcon = faLockOpen
    public loadingIcon = faCircleNotch

    private MOVEMENT_ITEM_CARD_LOCATION_CHANGED = MOVEMENT_ITEM_CARD_LOCATION_CHANGED
    private UPDATE_ITEM_MOVEMENT_PAGE = UPDATE_ITEM_MOVEMENT_PAGE

    private mounted() {
        this.$root.$on('bv::collapse::state', (collapseId, isShown) => {
            if(collapseId && collapseId === this.container.id) {
                this.onToggleContent(isShown)
            }
        })
    }

    private fetchContent() {
        let searchTypes = _uniq(ITEM_SEARCH_TYPES.concat([SEARCH_TYPES.physicalAccessoryItem, SEARCH_TYPES.physicalContainerItem]))
        this.isFetchingContent = true
        this.$containerDataStore
            .getAssociatedItems(this.container.id, searchTypes)
            .pipe(
                switchMap(identity), // extract inner list from Observable
                mergeAll(),
                toArray(),
            )
            .subscribe(items => {
                    this.subContainers = []
                    this.subItems = []
                    this.subAccessories = []
                    for(const item of items) {
                        switch(item.type) {
                            case 'physicalContainerItem':
                                this.subContainers.push(item as unknown as Container)
                                continue
                            case 'physicalAccessoryItem':
                                this.subAccessories.push(item)
                                continue
                            default:
                                this.subItems.push(item)
                                continue
                        }
                    }
                    this.contentFetched = true
                    this.isFetchingContent = false
            })
    }

    private get containerIcon() {
        if (this.container.containerItemSchema.openContainer) {
            return this.openedContainerIcon
        }

        if (this.container.containerItemSchema.openContainer === false) {
            return this.closedContainerIcon
        }
    }

    private onToggleContent(contentShown: boolean) {
        if(!this.contentFetched && contentShown) {
            this.fetchContent()
        }
    }
}
